import { axios } from '@/utils/request'
const api = "/Goods"
export default {
  SaveGoodsguivals: (parameter) => {
    return axios({
      url: `${api}/SaveGoodsguivals`,
      method: 'post',
      data: parameter
    }) 
  },
  deleteGoodsguivals: (parameter) => {
    return axios({
      url: `${api}/deleteGoodsguivals`,
      method: 'post',
      data: parameter
    }) 
  },
  SaveGoodsguivalss: (parameter) => {
    return axios({
      url: `${api}/SaveGoodsguivalss`,
      method: 'post',
      data: parameter
    }) 
  },
  CatsList: (parameter) => {
    return axios({
      url: `${api}/CatsList`,
      method: 'post',
      data: parameter
    }) 
  },
  GoodsCatList: (parameter) => {
    return axios({
      url: `${api}/GoodsCatList`,
      method: 'post',
      data: parameter
    }) 
  },
  guiList: (parameter) => {
    return axios({
      url: `${api}/guiList`,
      method: 'post',
      data: parameter
    }) 
  },
  GoodsvalsList: (parameter) => {
    return axios({
      url: `${api}/GoodsvalsList`,
      method: 'post',
      data: parameter
    }) 
  },
  GoodsvalsLists: (parameter) => {
    return axios({
      url: `${api}/GoodsvalsLists`,
      method: 'post',
      data: parameter
    }) 
  },
  Catspid: (parameter) => {
    return axios({
      url: `${api}/Catspid`,
      method: 'post',
      data: parameter
    }) 
  },
  GoodsList: (parameter) => {
    return axios({
      url: `${api}/GoodsList`,
      method: 'post',
      data: parameter
    }) 
  },
  specsList: (parameter) => {
    return axios({
      url: `${api}/specsList`,
      method: 'post',
      data: parameter
    }) 
  },
  Cats: (parameter) => {
    return axios({
      url: `${api}/Cats`,
      method: 'post',
      data: parameter
    }) 
  },

  deleteGoods: (parameter) => {
    return axios({
      url: `${api}/deleteGoods`,
      method: 'post',
      data: parameter
    }) 
  },
  SaveGoods: (parameter) => {
    return axios({
      url: `${api}/SaveGoods`,
      method: 'post',
      data: parameter
    }) 
  },
  AddGoods: (parameter) => {
    return axios({
      url: `${api}/AddGoods`,
      method: 'post',
      data: parameter
    }) 
  },
  SaveGoodsguivalsszj: (parameter) => {
    return axios({
      url: `${api}/SaveGoodsguivalsszj`,
      method: 'post',
      data: parameter
    }) 
  },
  deleteGoodsguivals: (parameter) => {
    return axios({
      url: `${api}/deleteGoodsguivals`,
      method: 'post',
      data: parameter
    }) 
  },
  FindGoods: (parameter) => {
    return axios({
      url: `${api}/FindGoods`,
      method: 'post',
      data: parameter
    }) 
  },
  AddCats: (parameter) => {
    return axios({
      url: `${api}/AddCats`,
      method: 'post',
      data: parameter
    })
  },
  AddGoodsCat: (parameter) => {
    return axios({
      url: `${api}/AddGoodsCat`,
      method: 'post',
      data: parameter
    })
  },
  FindCats: (parameter) => {
    return axios({
      url: `${api}/FindCats`,
      method: 'post',
      data: parameter
    })
  },
  SaveCats: (parameter) => {
    return axios({
      url: `${api}/SaveCats`,
      method: 'post',
      data: parameter
    })
  },
  DeleteCats: (parameter) => {
    return axios({
      url: `${api}/DeleteCats`,
      method: 'post',
      data: parameter
    })
  },

  FindGoodsCat: (parameter) => {
    return axios({
      url: `${api}/FindGoodsCat`,
      method: 'post',
      data: parameter
    })
  },
  
  
  GoodsCatpid : (parameter) => {
    return axios({
      url: `${api}/GoodsCatspid`,
      method: 'post',
      data: parameter
    })
  },
  SaveGoodsCat: (parameter) => {
    return axios({
      url: `${api}/SaveGoodsCat`,
      method: 'post',
      data: parameter
    })
  },
  DeleteGoodsCat: (parameter) => {
    return axios({
      url: `${api}/DeleteGoodsCat`,
      method: 'post',
      data: parameter
    })
  },
}